const starRatingStyles = {
  empty: '#D5DBDB',
  border: '#AC6518',
  fill: '#F9CF2F'
};
var starRatingStyles$1 = starRatingStyles;

export { starRatingStyles$1 as s };
//# sourceMappingURL=starRating-66f09d4c.js.map
